import { Component } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { FuseConfigService } from '../../core/services/config.service';
import { TranslateService } from '@ngx-translate/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { Http } from '@angular/http';
import { Subscription } from 'rxjs/Subscription';

@Component({
    selector: 'fuse-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss']
})

export class FuseToolbarComponent {
    userStatusOptions: any[];
    languages: any;
    selectedLanguage: any;
    showLoadingBar: boolean;
    horizontalNav: boolean;
    ipAddress: any;
    user: any;
    subscription = new Subscription();
    constructor(
        private router: Router,
        private fuseConfig: FuseConfigService,
        private translate: TranslateService,
        private afs: AngularFirestore,
        private _http: Http

    ) {
        this.subscription.add(afs.collection('users').doc(localStorage.getItem('currentUserId')).valueChanges().subscribe(user => {
            this.user = user;
        }));
        this.getIpAdress();


        // this.languages = [
        //     {
        //         'id'   : 'en',
        //         'title': 'English',
        //         'flag' : 'us'
        //     },
        //     {
        //         'id'   : 'tr',
        //         'title': 'Turkish',
        //         'flag' : 'tr'
        //     }
        // ];

        // this.selectedLanguage = this.languages[0];

        router.events.subscribe(
            (event) => {
                if (event instanceof NavigationStart) {
                    this.showLoadingBar = true;
                }
                if (event instanceof NavigationEnd) {
                    this.showLoadingBar = false;
                }
            });

        this.fuseConfig.onSettingsChanged.subscribe((settings) => {
            this.horizontalNav = settings.layout.navigation === 'top';
        });

    }
    getIpAdress() {
        // this.subscription.add(this._http.get("https://api.bigadvice.com/helper/ip")
        //     .map(data => { this.ipAddress = data.json() }).subscribe());
    }

    logout() {
        this.afs.collection('logs').add({
            userId: localStorage.getItem('currentUserId'),
            date: new Date(),
            type: 'logout',
            ipAddress: this.ipAddress,
            url: 'console.bigadvice.com'
        }).then(() => {

            localStorage.removeItem('currentUserId');
            this.router.navigate(['/auth']);
            localStorage.clear();
        });


    }

    search(value) {
        // Do your search here...
        console.log(value);
    }

    setLanguage(lang) {
        // Set the selected language for toolbar
        this.selectedLanguage = lang;

        // Use the selected language for translations
        this.translate.use(lang.id);
    }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/toolbar/toolbar.component.ts